import { DISPLAY_DATE_TIME_FORMAT, convertISOStringToLocalDateString } from '@core/date.services';
import { ECheckListTypeName } from './permitToLoadRemoveDetailPage.constants';
import { IProjectLoadingRemovalCertCheckList } from './permitToLoadRemoveDetailPage.models';

export interface ICheckListQuestion {
  name?: string;
  checkBoxFieldValue?: boolean;
  commentFieldValue?: any;
  type?: string;
  questions?: ICheckListQuestion[];
}

interface IProjectLoadingRemovalCertCheckListQuestion {
  q1: ICheckListQuestion;
  q2: ICheckListQuestion;
  q3: ICheckListQuestion;
  q4: ICheckListQuestion;
  q5?: ICheckListQuestion;
}

const generateCommonQ1 = (checkListDetail: IProjectLoadingRemovalCertCheckList): ICheckListQuestion[] => {
  return [
    {
      name: 'Planned Start Time',
      commentFieldValue: convertISOStringToLocalDateString(checkListDetail.planStart, DISPLAY_DATE_TIME_FORMAT),
      type: 'dateTime',
    },
    {
      name: 'Planned Finish Time',
      commentFieldValue: convertISOStringToLocalDateString(checkListDetail.planFinish, DISPLAY_DATE_TIME_FORMAT),
      type: 'dateTime',
    },
    { name: 'Pour Height', commentFieldValue: `${checkListDetail.pourHeight} m`, type: 'meter' },
    {
      name: 'Rate of Rise of Concrete (Planning)',
      commentFieldValue: `${checkListDetail.planRate} m/hr`,
      type: 'meterRate',
    },
    {
      name: 'Rate of Rise of Concrete (Specified in Design)',
      commentFieldValue: `${checkListDetail.designRate} m/hr`,
      type: 'meterRate',
    },
    {
      name: `
          Rate of Rise of Concrete (Planning)
                            <=
          Rate of Rise of Concrete (Specified in Design)`,
      checkBoxFieldValue: !!(checkListDetail.planRate <= checkListDetail.designRate),
      type: 'checkbox',
    },
  ];
};

export const permitToLoadRemovalCheckListQuestionMapper = (
  checkListDetail: IProjectLoadingRemovalCertCheckList,
): IProjectLoadingRemovalCertCheckListQuestion | undefined => {
  switch (checkListDetail.checkListType.name) {
    case ECheckListTypeName.Falsework.toString():
      return {
        q1: {
          name: 'Falsework Layout according to approved drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q1,
          commentFieldValue: checkListDetail.q1comment,
        },
        q2: {
          name: 'All Head Jack and Base Jack Extension less than 300mm?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q2,
          commentFieldValue: checkListDetail.q2comment,
        },
        q3: {
          name: 'All Bracings installed according to approved drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q3,
          commentFieldValue: checkListDetail.q3comment,
        },
        q4: {
          name: 'Eccentric Load is eliminated at all Forkhead supports by centralizing the bearers?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q4,
          commentFieldValue: checkListDetail.q4comment,
        },
        q5: {
          name: 'Base Plate supported on firm base?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q5,
          commentFieldValue: checkListDetail.q5comment,
        },
      };
    case ECheckListTypeName.TimberFormwork.toString():
      return {
        q1: {
          questions: generateCommonQ1(checkListDetail),
          type: 'array',
        },
        q2: {
          name: 'All Materials and Member Sizes according to approved drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q2,
          commentFieldValue: checkListDetail.q2comment,
        },
        q3: {
          name: 'All Member Configurations including spacing according to approved drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q3,
          commentFieldValue: checkListDetail.q3comment,
        },
        q4: {
          name: 'Wind Bracing Struts firmly fixed as necessary according to drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q4,
          commentFieldValue: checkListDetail.q4comment,
        },
      };
    case ECheckListTypeName.AluminiumFormwork.toString():
      return {
        q1: {
          questions: generateCommonQ1(checkListDetail),
          type: 'array',
        },
        q2: {
          name: 'All Formwork Waling installed according to approved drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q2,
          commentFieldValue: checkListDetail.q2comment,
        },
        q3: {
          name: 'All Wall Ties and Props installed according to approved drawings?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q3,
          commentFieldValue: checkListDetail.q3comment,
        },
        q4: {
          name: 'All Connections are fully engaged?',
          type: 'string',
          checkBoxFieldValue: checkListDetail.q4,
          commentFieldValue: checkListDetail.q4comment,
        },
      };

    default:
      return undefined;
  }
};
